module.exports = __webpack_public_path__ + "static/TFF_Wedgeeagle-74dd133c47137f793d1c6241740c3bc1.jpg";